import { GeoFile } from '@scalenc/geo-format/dist/model/GeoFile';
import { BackendErrorMessage } from 'src/app/core/services/notify.service';
import { SizeUnit } from 'src/app/shared/models/unit.models';
import { ProductionStep } from './articles.models';

type FileType = 'geo' | 'svg';

export interface LoadedSvgFile {
    fileName: string;
    file: File;
    isLoading: boolean;
    error: string | null;
}

export interface LoadedStlFile {
    fileName: string;
    file: File;
    isLoading: boolean;
    error: string | null;
}

export interface LoadedGeoFile {
    fileName: string;
    file: File;
    content: string;
    fileType: FileType;
    geoFile: GeoFile | null;
    partsCount: number;
    isLoading: boolean;
    error: string | null;
}

export interface DrawingImportResponseDto {
    id: string;
    startTime: string | null; //date-time
    finishTime: null | string; //date-time
    state: DrawingImportState;
    importedArticleName: null | string;
    importedArticleType: ImportedArticleType;
    has2DPreview: null | boolean;
    has3DPreview: null | boolean;
    size2D: Size2D;
    size3D: Size3D;
    sheetMetalThickness: SheetMetalThickness;
    productionSteps: ProductionStep[];
    error: null | DrawingImportError;
}

export enum DrawingImportState {
    Queued = 'Queued',
    Pending = 'Pending',
    Processing = 'Processing',
    Completed = 'Completed',
    Failed = 'Failed',
}

export enum ImportedArticleType {
    Part = 'Part',
    Assembly = 'Assembly',
    // Sheet = 'Sheet',
    Tube = 'Tube',
    Other = 'Other',
}

export interface Size2D {
    x: number;
    y: number;
    unit: SizeUnit;
}

export interface Size3D {
    x: number;
    y: number;
    z: number;
    unit: SizeUnit;
}

export interface SheetMetalThickness {
    value: number;
    unit: SizeUnit;
}

export interface DrawingImportError extends BackendErrorMessage {
    affectedProperties: string[];
}
